import {
  CardHolderAccount,
  ICardHolderAccount,
} from './../models/authentication-request/card-holder-account.model';
import {
  CardHolder,
  ICardHolder,
} from './../models/authentication-request/card-holder.model';
import { AuthenticationRequest } from './../models/authentication-request/authentication-request.model';
import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { IAuthenticationRequest } from '../models/authentication-request/authentication-request.model';
import {
  IBrowserInformation,
  BrowserInformation,
} from '../models/authentication-request/browser-information.model';
import { BuyerInformationComponent } from 'src/app/components/buyer-information/buyer-information.component';
import { CardsScheme } from '../enums/scheme.enum';
import { Acquirer, IAcquirer } from '../models/authentication-request/acquirer.model';
import { IMobilePhone } from '../models/authentication-request/mobile-phone.model';
import { GENERAL_CONSTANTS } from '../../constants/General-constants';

@Injectable({
  providedIn: 'root',
})
export class ThreeDsAuthenticationService {
  constructor() { }

  buildThreeDsAuthenticationRequest(
    form: FormGroup,
    buyerComponent: BuyerInformationComponent,
    franchise: string,
    threeDSCompInd?: string
  ): IAuthenticationRequest {
    const cardHolder: ICardHolder = this.buildCardHolder(
      [
        'billAddrCity',
        'billAddrLine1',
        'billAddrLine2',
        'billAddrLine3',
        'billAddrPostCode',
      ],
      form,
      buyerComponent
    );

    const iAcquirer: IAcquirer = new Acquirer();
    const request: IAuthenticationRequest = new AuthenticationRequest();

    const browserInformation: IBrowserInformation = this.buildBrowserInformation();
    const cardHolderAccount: ICardHolderAccount = this.buildCardHolderAccount(form, franchise);

    request.browserInformation = browserInformation;
    request.cardholder = cardHolder;
    request.cardholderAccount = cardHolderAccount;
    iAcquirer.acquirerBin = cardHolderAccount.acctNumber.substring(0, 6)
    request.acquirer = iAcquirer;
    request.threeDSCompInd = threeDSCompInd;

    return request;
  }

  buildThreeDsValidatorRequest(
    form: FormGroup,
    buyerComponent: BuyerInformationComponent,
    franchise: string,
  ): IAuthenticationRequest {
    const cardHolder: ICardHolder = this.buildCardHolder(
      [
        'billAddrCity',
        'billAddrLine1',
        'billAddrLine2',
        'billAddrLine3',
        'billAddrPostCode',
      ],
      form,
      buyerComponent
    );

    const browserInformation: IBrowserInformation = this.buildBrowserInformation();
    const cardHolderAccount: ICardHolderAccount = this.buildCardHolderAccount(form, franchise);

    const request: any = {
      threeDSVersioningRequest: {
        cardholderAccountNumber: cardHolderAccount.acctNumber,
      },
      threeDSAuthenticationRequest: {
        browserInformation: browserInformation,
        cardholder: cardHolder,
        cardholderAccount: cardHolderAccount,
        cardholderDocument: form.get('di').value.toString(),
        acquirer: {
          acquirerBin: cardHolderAccount.acctNumber.substring(0, 6),
        },
      },
    };

    return request;
  }

  /**
   *
   * @description {buildCardHolder} Function that builds the information for the 3ds iframe.
   * @param formControlNameList
   * @param form
   * @param buyerComponent
   * @returns CardHolder
  */
  private buildCardHolder(formControlNameList: string[], form: FormGroup, buyerComponent: BuyerInformationComponent): CardHolder {
    let cardHolder: ICardHolder = new CardHolder();

    try {
      let subscriberPhone = buyerComponent.form.controls.cellPhone ? buyerComponent.form.controls.cellPhone.value : 0;
      let requestMobile: IMobilePhone = { cc: GENERAL_CONSTANTS.PHONE_PREFIX_COLOMBIA_3DS, subscriber: subscriberPhone };

      if (formControlNameList && formControlNameList.length > 0) {
        formControlNameList.forEach((formControlName) => {
          cardHolder[formControlName] = form.get(formControlName).value.replace(/['"]+/g, '');
        });
      }

      cardHolder.billAddrCountry = form.get('billAddrCountry').value.replace(/['"]+/g, '');
      cardHolder.billAddrState = form.get('billAddrState').value.replace(/['"]+/g, '');
      cardHolder.cardholderName = `${form.get('name').value} ${form.get('lastname').value}`;
      cardHolder.email = buyerComponent.form.controls.email.value;
      cardHolder.mobilePhone = requestMobile;
    } catch (_) {
      cardHolder = {};
    }

    return cardHolder;
  }


  private buildCardHolderAccount(form: FormGroup, franchise: string): CardHolderAccount {
    const cardHolderAccount: ICardHolderAccount = new CardHolderAccount();

    cardHolderAccount.acctNumber = form.get('cardNumber').value;
    cardHolderAccount.schemeID = CardsScheme[franchise];
    cardHolderAccount.cardExpiryDate = `${form.get('expirationYear').value}${form.get('expirationMonth').value}`;

    return cardHolderAccount;
  }

  private buildBrowserInformation(): BrowserInformation {
    const browser: IBrowserInformation = new BrowserInformation();
    browser.browserJavaEnabled = navigator.javaEnabled()
    browser.browserUserAgent = navigator.userAgent;
    browser.browserLanguage = navigator.language;
    browser.browserColorDepth = screen.colorDepth.toString();
    browser.browserScreenWidth = screen.width;
    browser.browserScreenHeight = screen.height;
    browser.browserTZ = this.getTimeZone();
    browser.challengeWindowSize = '01';

    return browser;
  }


  private getTimeZone(): number {
    const date = new Date();

    return date.getTimezoneOffset();
  }
}
